import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import BoosterHeader from "../../components/booster-header/component";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class BoosterResetPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            error: false,
            success: false,
            password: "",
            password_confirm: "",
            code: ""
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        try{
            if(this.props.match.params.code){
                this.setState({code: this.props.match.params.code});
            }
        }catch (e) {}

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/changepassword');
            ReactGA4.send({ hitType: "pageview", page: "/changepassword" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
    }

    _send(){
        this.setState({isLoading: true, error: false});
        let data = {new_password: this.state.password, new_password_confirm: this.state.password_confirm, pin_code: this.state.code};
        dataRegister.resetPassword(salesChannelRegister.get('market'), data).then((item) => {
            if(!item.errors){
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
            }
        }, (error) => {
            this.setState({isLoading: false, error: true});
        });
    }

    _back(){
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
    }

    _renderButton(){
        if (!this.state.isLoading) {
            return (this._renderText("item_4"));
        } else {
            return (<BeatLoader size={9} color={'#ffffff'} loading={true}/>);
        }
    }

    _renderText(item) {
        return langRegister.get("changepassword", item);
    }

    render() {
        return (
            <div>
                <BoosterHeader view={"login"} props={this.props}/>
                <div className={Styles.container}>
                    <div style={salesChannelRegister.get('name') === "yieldlock"?{color: '#E65032'}:{}} className={Styles.title}>
                        {this._renderText("item_1")}
                    </div>
                    <div className={Styles.subtitle}>
                        {this._renderText("item_2")}
                    </div>
                    <span className={Styles.inputContainer}>
                        <div className={Styles.inputContainer}>
                            <input
                                className={
                                    cx(Styles.input)
                                }
                                type={"password"}
                                placeholder={this._renderText("item_3")}
                                value={this.state.password}
                                onChange={(event) => this.setState({password: event.target.value})}
                            />
                            {
                                this.state.error &&
                                <div style={salesChannelRegister.get('name') === "yieldlock"?{backgroundColor: '#E65032'}:{}} className={Styles.inputError}/>
                            }
                        </div>
                        <div className={Styles.inputContainer}>
                            <input
                                className={
                                    cx(Styles.input)
                                }
                                type={"password"}
                                placeholder={this._renderText("item_6")}
                                value={this.state.password_confirm}
                                onChange={(event) => this.setState({password_confirm: event.target.value})}
                            />
                            {
                                this.state.error &&
                                <div style={salesChannelRegister.get('name') === "yieldlock"?{backgroundColor: '#E65032'}:{}} className={Styles.inputError}/>
                            }
                        </div>
                    </span>
                    <div onClick={() => this._send()} className={Styles.button}>
                        {this._renderButton()}
                    </div>
                    <div onClick={() => this._back()} className={Styles.backButton}>
                        {this._renderText("item_5")}
                    </div>
                </div>
            </div>
        );
    }
}

export default BoosterResetPassword;


// WEBPACK FOOTER //
// ./src/pages/booster-reset-password/component.js